module.exports = __webpack_public_path__ + "static/media/lumbering5.582dc9d7.jpg";